import {DocumentOwnerType} from "~/enums/documentOwnerType";

export enum ObjectModelRecordHolderType {
  Individual = 1,
  Entity = 2,
  None = 3
}

export const objectModelHolderTypeToDocumentOwnerType ={
  [ObjectModelRecordHolderType.Individual]: DocumentOwnerType.individual,
  [ObjectModelRecordHolderType.Entity]: DocumentOwnerType.entity,
  [ObjectModelRecordHolderType.None]: DocumentOwnerType.noOwner,
}

export const holderTypeWithOwner = [
  ObjectModelRecordHolderType.Individual,
  ObjectModelRecordHolderType.Entity
]

export const ObjectModelRecordHolderTypeName = {
  [ObjectModelRecordHolderType.Individual]: "Individual",
  [ObjectModelRecordHolderType.Entity]: "Entity",
  [ObjectModelRecordHolderType.None]: "None"
};
